export default {
  date: 'May 8, 2024',
  title: 'What types of views can Getfloorplan generate from the window?',
  description: 'Explore the enticing array of views that not only capture the imagination but also allure potential real estate buyers',
  id: 'types-of-views',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        Explore the variety of views that capture the imagination and attract potential real estate buyers, aiding in making faster decisions on property purchases:
        <br></br>
        <br></br>
        1. City View: Perfect for urbanites craving a vibrant lifestyle with easy access to amenities and entertainment.
        <br></br>
        <br></br>
        2. Village View: Ideal for those who cherish a peaceful, tight-knit community vibe with a hint of rustic charm.
        <br></br>
        <br></br>
        3. Garden View: Tailored for nature enthusiasts who appreciate tranquility, bringing the beauty of the outdoors inside with lush, green surroundings.
        <br></br>
        <br></br>
        4. Sandy Shore View: Designed for beach aficionados, offering stunning ocean views and a laid-back, coastal lifestyle.
        <br></br>
        <br></br>
        5. Pool View: Suited for individuals seeking luxury and leisure, featuring a private oasis complete with a refreshing swim and appealing landscape.
        <br></br>
      </p>
      <p>
        Experience the enchantment of these captivating views firsthand by trying out our innovative artificial intelligence service. Whether you're a real estate developer looking to enhance property offerings or a private seller of residential space, our technology will help you visualize the
        possibilities with stunning accuracy and sell properties faster.
      </p>
    </div>
  ),
  thumb: 'news/16.webp',
};
